import { Grid } from "@mui/material";
import {
  Cell,
  type Props as CellProps,
} from "Components/Merchant/Initiate/InitiatePaymentKeypad/Keypad/Cell";
import { CellWrapper } from "Components/Merchant/Initiate/InitiatePaymentKeypad/Keypad/CellWrapper";

type Props = {
  grid: Array<Array<CellProps>>;
};

export const Keypad = ({ grid }: Props) => (
  <Grid container alignItems="stretch" spacing={0} sx={{ width: "100%" }}>
    <Grid sx={{ flex: 1 }}>
      {grid.map((row, rowIndex) => (
        <Grid
          // biome-ignore lint/suspicious/noArrayIndexKey: order never changes
          key={rowIndex}
          container
          sx={{ width: "100%" }}
        >
          {row.map(({ label, onClick }, colIndex) => {
            const isLastRow = rowIndex === grid.length - 1;
            const isLastColumn = colIndex === row.length - 1;

            return (
              <CellWrapper
                // biome-ignore lint/suspicious/noArrayIndexKey: order never changes
                key={colIndex}
                hasBottomBorder={!isLastRow}
                hasRightBorder={!isLastColumn}
              >
                <Cell label={label} onClick={onClick} />
              </CellWrapper>
            );
          })}
        </Grid>
      ))}
    </Grid>
  </Grid>
);
